import { Input } from "antd";

export default function CrrPassword(props) {
  const { selectField, placeholderText, onChange, setValue, visibilityToggle } =
    props;
  return (
    <Input.Password
      className="login-input"
      placeholder={!selectField && placeholderText}
      bordered={false}
      onChange={(e) => {
        setValue(e.target.value);
        onChange && onChange(e.target.value);
      }}
      visibilityToggle={visibilityToggle}
    />
  );
}
